export enum DIMS_AND_WEIGHT_ERRORS {
  INVALID_DIMS_QR_CODE = "INVALID_DIMS_QR_CODE",
}

export enum DimsAndWeightImageUploadField {
  SCREEN_PICTURE = "screenPicture",
  PRODUCT_PICTURE = "productPicture",
  ALL_PICTURE = "allPicture",
}
